<template>
    <v-container>
        <v-dialog v-model="dialog" width="609" @click:outside="closeModal">
        <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
            <v-toolbar-title class="font-weight-bold">{{
                $t("animal.addReport")
            }}</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            </v-toolbar>
            <v-form
                autocomplete="off"
                ref="form"
                v-model="valid"
                @submit.prevent="addReport"
            >
            <v-card-text class="black--text">
                <label class="title" for="name">{{ $t("animal.report.activity") }}</label>
                <v-textarea
                    v-model="report.activity"
                    outlined
                    counter
                    class="mt-3"
                ></v-textarea>

                <label
                    class="subtitle-1 font-weight-medium"
                    for="animalRemovalDate"
                >Date
                </label>
                <v-menu
                  v-model="addReportDateModel"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="report.date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      v-on:click:append="addReportDateModel=true"
                      outlined
                      dense
                      placeholder="Select date"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="report.date"
                    @input="addReportDateModel = false"
                  ></v-date-picker>
                </v-menu>

                <label class="title" for="name">{{ $t("animal.report.status") }}</label>
                <v-text-field
                    type="text"
                    v-model="report.status"
                    placeholder="Status"
                    outlined
                    dense
                ></v-text-field>

                <v-card-actions class="">
                <v-spacer></v-spacer>
                <v-btn
                    class=""
                    outlined
                    color="primary"
                    @click="closeModal"
                    width="112"
                >
                    {{ $t("cancel") }}
                </v-btn>
                <v-btn
                    type="submit"
                    width="112"
                    color="primary"
                    class="btn-11 btn-22"
                >
                    {{ $t("submit") }}
                </v-btn>
                </v-card-actions>
            </v-card-text>
            </v-form>
        </v-card>
        </v-dialog>
  </v-container>
</template>

<script>
import loading from "@/mixins/LoadingMixin";

import gql from 'graphql-tag';

export default {
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  data() {
    return {
      addReportDateModel: false,
      valid: true,
      report: {},
    };
  },
  methods: {
    closeModal() {
      this.$emit("dialog:close");
    },
    addReport() {
      if (!this.$refs.form.validate()) return;
      this.startLoading();

      this.$apollo.mutate({
        mutation: gql`mutation ($data: CreateReportInput!) {
          createReport (createReportInput: $data) {
            id
          }
        }`,
        variables: {
          data: {
            animalId: parseInt(this.$route.params.animal_number),
            activity: this.report.activity,
            date: this.report.date,
            status: this.report.status,
          },
        },
      })
        .then((respose) => {
          this.stopLoading();
          if (respose.data.createReport) {
            this.$notify({
              title: this.$t("animal.reportAdded"),
              type: this.$t("success"),
            });
            this.$emit("dialog:close");
            this.$emit("report:added");
          } else {
            console.log(respose);
            this.$notify({
              title: this.$t("animal.reportNotAdded"),
              type: this.$t("error"),
            });
            this.$emit("dialog:close");
          }
        })
        .catch((error) => {
          this.stopLoading();
          console.log("err", error);
        });
    },
  },

  props: ["dialogI"],
  mixins: [loading],
};
</script>
<style lang="scss" scoped>
</style>
